import React from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';


import { HomePage } from 'home-page';
import { LoginPage } from 'login-page';
import { LogoutPage } from 'logout-page';
import { SearchPage } from 'search-page';
import { PracticePage } from 'practice-page';
import { SpecialistPage } from 'specialist-page';
import { GlobalComponents } from 'global-components';
import {
	Career,
	Contact,
	SocialMedia,
	Mission,
	PatientFaqs,
	CookiePolicy,
	PrivacyPolicy,
	TermsAndConditions,
	AcceptableUsePolicy
} from 'info-page';

import { ErrorPage } from 'error-page';

import { syncHistoryWithStore } from 'react-router-redux';

const locale = 'en';
const [localeBase, ] = locale.split('-');
const lang = require(`react-intl/locale-data/${localeBase}`);
let messages;
try {
	messages = require(`../../src/lang/${localeBase}.json`);
} catch (error) {
	messages = require('../../src/lang/en.json');
}
addLocaleData(lang);

export const routes = (store) => (
	<IntlProvider locale={localeBase} messages={messages}>
		<Router history={ store ?  syncHistoryWithStore(browserHistory, store) : browserHistory }>
			<Route path="/" component={GlobalComponents}>
				<IndexRoute component={HomePage}/>
				<Route path="/login" component={LoginPage}/>
				<Route path="/search" component={SearchPage}/>
				<Route path="/specialist/:id" component={SpecialistPage}/>
				<Route path="/practice/:id" component={PracticePage}/>
				<Route path="/search/specialist/:id" component={SpecialistPage}/>
				<Route path="/search/practice/:id" component={PracticePage}/>
				<Route path="/career" component={Career}/>
				<Route path="/contact" component={Contact}/>
				<Route path="/mission" component={Mission}/>
				<Route path="/patient-faqs" component={PatientFaqs}/>
				<Route path="/social-media" component={SocialMedia}/>
				<Route path="/cookie-policy" component={CookiePolicy}/>
				<Route path="/privacy-policy" component={PrivacyPolicy}/>
				<Route path="/terms-and-conditions" component={TermsAndConditions}/>
				<Route path="/acceptable-use-policy" component={AcceptableUsePolicy}/>
                <Route path="/404" component={ErrorPage} />
			</Route>
			<Route path="/logout" component={LogoutPage}/>
		</Router>
	</IntlProvider>
);



// WEBPACK FOOTER //
// ./src/client/routes.jsx